import { useMutation } from 'react-query'
import { getCTSDK } from 'services/ctClient'
import { Doc, DocDynamicType } from 'types/doc.types'
import { EntityType } from 'types/entity.types'

const sdk = getCTSDK()

const BASE_URL = '/docs'
const ELEMENT_NAME = 'doc'
type Model = Doc

export const useUploadDocuments = () => {
    return useMutation(
        (args: {
            entityId: string
            entityType: EntityType
            customerId?: string | null
            meta?: Record<string, unknown>
            formData: FormData
        }) => {
            args.formData.append('entityId', args.entityId)
            args.formData.append('entityType', args.entityType)
            if (args.meta)
                args.formData.append('meta', JSON.stringify(args.meta))

            return sdk
                .post<{ documents: Model[] }>(`${BASE_URL}`, args.formData)
                .then((res) => res.data.documents)
        }
    )
}

export const useDeleteDocumentById = () => {
    return useMutation((documentId: string) =>
        sdk.delete(`${BASE_URL}/${documentId}`)
    )
}

export const useDeleteDocs = () => {
    return useMutation((docIds: string[]) =>
        sdk.delete(BASE_URL, {
            data: { docIds },
        })
    )
}

export const useUpdateDocById = () => {
    return useMutation((data: { id: string; [ELEMENT_NAME]: Partial<Model> }) =>
        sdk
            .put<{ [ELEMENT_NAME]: Model }>(`${BASE_URL}/${data.id}`, {
                [ELEMENT_NAME]: data[ELEMENT_NAME],
            })
            .then((res) => res.data[ELEMENT_NAME])
    )
}

export const useGenerateDocPdf = () => {
    return useMutation(
        async ({
            entityId,
            entityType,
            docDynamicType,
            dropoffId,
        }: {
            entityId: string
            entityType: EntityType
            docDynamicType: DocDynamicType
            dropoffId?: string | null
        }) =>
            sdk
                .post<Blob>(
                    `${BASE_URL}/view/${entityType}/${entityId}/${docDynamicType}`,
                    { dropoffId },
                    {
                        responseType: 'blob', // Ensure the response is treated as a binary PDF
                    }
                )
                .then((res) => res.data)
    )
}
